import styled, { css } from 'styled-components'

import type { Size } from '../types'

export const Container = styled.div`
  display: block;
  vertical-align: middle;
`

export const InternalCheckbox = styled.input.attrs({ type: 'checkbox' })`
  /* スクリーンリーダーなどには対応しつつ、見た目上だけ隠す */
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

interface CheckboxContainerProps {
  size?: Size
  checked?: boolean
  disabled?: boolean
}

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  display: inline-block;
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  user-select: none;

  ${({ size }) =>
    size === 'large' &&
    css`
      height: 24px;
      width: 24px;

      & > svg {
        height: 24px;
        width: 24px;
      }
    `}

  ${({ size }) =>
    size === 'medium' &&
    css`
      height: 20px;
      width: 20px;

      & > svg {
        height: 20px;
        width: 20px;
      }
    `}
`
